import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import pt from './locales/pt.json';
import en from './locales/en.json';

export const supportedLanguages = ['pt', 'en'] as const;
export type Language = (typeof supportedLanguages)[number];

/** Maps app language codes to full BCP-47 locales for Intl formatting. */
export const localeMap: Record<Language, string> = {
  pt: 'pt-PT',
  en: 'en-GB',
};

export const resources = {
  pt: { translation: pt },
  en: { translation: en },
} as const;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt',
    supportedLngs: [...supportedLanguages],
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'conduril-partes-lang',
    },
  });

export default i18n;
